<template>
    <span class="k-num-money" :class="className">
        <span class="num_money">{{text}}</span><span class="num_unit">元</span>
    </span>
</template>

<script>
    import {isBoolean} from '../../common/utils'
    export default {
        name: 'k-num-money',
        props: ['value', 'sign'],
        computed: {
            _sign() {
                return isBoolean(this.sign) ? this.sign : false
            },
            className() {
                const {value} = this
                return this._sign ? value < 0 ? 'cl_fall' : value > 0 ? 'cl_rise' : 'cl_flat' : ''
            },
            text() {
                const value = this.value
                return (value > 0 && !!this._sign ? '+' : '') + (+value).toFixed(2)
            }
        }
    };

</script>
